import * as React from "react";
import {Footer} from '../../component/layout/Footer';
import {Navigation} from '../../component/layout/Navigation';
import {SocietyReportGridItem} from '../../component/society-report/SocietyReportGridItem';
import {ReportApiService} from "../../core/api/report/ReportApiService";
import {IReadReportResponse} from "../../core/api/report/response/IReadReportResponse";
import {ICreateReportRequest} from "../../core/api/report/request/CreateReportRequest";
import {IFileRequest} from "../../core/api/common/request/FileRequest";
import FileBase64 from 'react-file-base64';
import {StateManager} from "../../core/utility/StateManager";
import {ICoreState} from "../../component/common/CoreState";
import coreState from "../../component/common/CoreState";
import {CoreConstant} from "../../core/utility/CoreConstant";

interface IProps {
    componentName?: string;
}

interface IState {
    isShowAspirasiForm: boolean;
    isShowPengaduanForm: boolean;
    data: IReadReportResponse[] | undefined;
    request: ICreateReportRequest;
    imageRequest: IFileRequest | undefined;
    coreState: ICoreState;
}

export class SocietyReport extends React.Component<IProps, IState> {

    private readonly apiService = new ReportApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            coreState,
            isShowAspirasiForm: false,
            isShowPengaduanForm: false,
            data: undefined,
            request: {
                address: '',
                category: '',
                description: '',
                identityNumber: 0,
                imageFile: undefined,
                name: '',
                phone: '',
                title: ''
            },
            imageRequest: undefined
        };

    }

    public componentDidMount = () =>{
        this.fetchData();
    };

    public render() {
        return (
            <div id="citizen-report-page" className="page client-area">
                <Navigation navClass="main-nav no-js" />

                <section className="page-section bg-dark-alfa-30 parallax-3 dusun-header-section">
                    <div className="relative container align-left">
                        <div className="row">
                            <div className="col-md-8">
                                <h1 className="hs-line-11 font-alt mb-20 mb-xs-0">Aspirasi & Pengaduan</h1>
                                <div className="hs-line-4 font-alt black">Sistem Informasi Aspirasi & Pengaduan masyarakat</div>
                            </div>
                            <div className="col-md-4 mt-30">
                                <div className="mod-breadcrumbs font-alt align-right"><a
                                    href="/">Beranda</a>&nbsp;/&nbsp;Aspirasi & Pengaduan</div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="page-section">
                    <div className="container relative">
                        <div className="row">
                            <div className="col-sm-10 col-sm-offset-1">

                                <div className="row">
                                    <div className="col-md-12 text-center mb-40">
                                        <button className="btn btn-mod btn-circle btn-large mr-10 mb-10" onClick={this.showAspirasiForm}>Sampaikan Aspirasi</button>
                                        <a className="btn btn-mod btn-circle btn-large mb-10" onClick={this.showPengaduanForm}>Sampaikan Pengaduan</a>

                                    </div>
                                </div>

                                {this.state.coreState.isLoading && this.state.coreState.loadingNotification}

                                {this.state.isShowAspirasiForm && (
                                    <div className="form-wrapper mb-40">
                                        <form className="form">
                                            <div className="form-group">
                                                <label htmlFor="nama">Judul</label>
                                                <input
                                                    value={this.state.request.title}
                                                    onChange={this.formListener}
                                                    type="text"
                                                    className="input-md form-control"
                                                    id="title"
                                                    placeholder="Contoh: Buat aplikasi layanan satu pintu"
                                                    name="title" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="deskripsi">Apa Aspirasimu?</label>
                                                <textarea
                                                    value={this.state.request.description}
                                                    onChange={this.formListener}
                                                    className="input-md form-control"
                                                    rows={10}
                                                    name="description" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="nama">Nama</label>
                                                <input
                                                    value={this.state.request.name}
                                                    onChange={this.formListener}
                                                    type="text"
                                                    className="input-md form-control"
                                                    id="name"
                                                    placeholder="Nama lengkapmu"
                                                    name="name" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="alamat">Alamat</label>
                                                <input
                                                    value={this.state.request.address}
                                                    onChange={this.formListener}
                                                    type="text"
                                                    className="input-md form-control"
                                                    id="address"
                                                    placeholder="Alamat tinggal"
                                                    name="address" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="no_ktp">No. KTP</label>
                                                <input
                                                    value={this.state.request.identityNumber}
                                                    onChange={this.formListener}
                                                    type="number"
                                                    className="input-md form-control"
                                                    id="identityNumber"
                                                    placeholder="No. KTP"
                                                    name="identityNumber" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="telp">No. Telp</label>
                                                <input
                                                    value={this.state.request.phone}
                                                    onChange={this.formListener}
                                                    type="number"
                                                    className="input-md form-control"
                                                    id="phone"
                                                    placeholder="No. Telp"
                                                    name="phone" />
                                            </div>
                                            <input
                                                onClick={(e: any) => this.sendReport(e, CoreConstant.ReportCategory.Aspiration)}
                                                type="button"
                                                className="btn btn-mod btn-medium btn-round mr-10"
                                                value="Simpan" />
                                            <input
                                                onClick={this.cancelForm}
                                                type="button"
                                                className="btn btn-mod btn-border btn-medium btn-round"
                                                name="cancelForm"
                                                defaultValue="Batal" />
                                        </form>
                                        <hr />
                                    </div>
                                )}

                                {this.state.isShowPengaduanForm && (
                                    <div className="form-wrapper mb-40">
                                        <form className="form">
                                            <div className="form-group">
                                                <label htmlFor="nama">Judul</label>
                                                <input
                                                    value={this.state.request.title}
                                                    onChange={this.formListener}
                                                    type="text"
                                                    className="input-md form-control"
                                                    id="title"
                                                    placeholder="Contoh: Jalan rusak di daerah Dusun ABC"
                                                    name="title" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="deskripsi">Apa Pengaduanmu?</label>
                                                <textarea
                                                    value={this.state.request.description}
                                                    onChange={this.formListener}
                                                    className="input-md form-control"
                                                    rows={10}
                                                    name="description" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="gambar">Gambar (Jika ada)</label>
                                                <FileBase64
                                                    multiple={false}
                                                    onDone={this.imageFormListener} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="nama">Nama</label>
                                                <input
                                                    value={this.state.request.name}
                                                    onChange={this.formListener}
                                                    type="text"
                                                    className="input-md form-control"
                                                    id="name"
                                                    placeholder="Nama lengkapmu"
                                                    name="name" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="alamat">Alamat</label>
                                                <input
                                                    value={this.state.request.address}
                                                    onChange={this.formListener}
                                                    type="text"
                                                    className="input-md form-control"
                                                    id="address"
                                                    placeholder="Alamat tinggal"
                                                    name="address" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="no_ktp">No. KTP</label>
                                                <input
                                                    value={this.state.request.identityNumber}
                                                    onChange={this.formListener}
                                                    type="number"
                                                    className="input-md form-control"
                                                    id="identityNumber"
                                                    placeholder="No. KTP"
                                                    name="identityNumber" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="telp">No. Telp</label>
                                                <input
                                                    value={this.state.request.phone}
                                                    onChange={this.formListener}
                                                    type="number"
                                                    className="input-md form-control"
                                                    id="phone"
                                                    placeholder="No. Telp"
                                                    name="phone" />
                                            </div>

                                            <input
                                                onClick={(e: any) => this.sendReport(e, CoreConstant.ReportCategory.Report)}
                                                type="button"
                                                className="btn btn-mod btn-medium btn-round mr-10"
                                                value="Simpan" />
                                            <input
                                                onClick={this.cancelForm}
                                                type="button"
                                                className="btn btn-mod btn-border btn-medium btn-round"
                                                name="cancelForm"
                                                defaultValue="Batal" />
                                        </form>
                                        <hr />
                                    </div>
                                )}

                                {this.state.data === undefined ? <p>Loading...</p> : (
                                    <div>
                                        {this.state.data.length < 1 ? <p>Data tidak ditemukan.</p> : this.state.data.map((item, index) =>
                                            <SocietyReportGridItem key={index} data={item}  />
                                        )}
                                    </div>
                                )}

                                {/*<div className="pagination">
                                    <a className="active" href="blog-classic-fullwidth.html">1</a>
                                    <a href="blog-classic-fullwidth.html">2</a>
                                    <a href="blog-classic-fullwidth.html">3</a>
                                    <a className="no-active">...</a>
                                    <a href="blog-classic-fullwidth.html">9</a>
                                </div>*/}

                            </div>
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        );
    }

    private showAspirasiForm = () => {
        this.setState({
            isShowAspirasiForm: true,
            isShowPengaduanForm: false
        })
    };

    private showPengaduanForm = () => {
        this.setState({
            isShowAspirasiForm: false,
            isShowPengaduanForm: true
        })
    };

    private cancelForm = () => {
        this.setState({
            isShowAspirasiForm: false,
            isShowPengaduanForm: false
        })
    };

    private fetchData = () => {
        this.apiService.getPublishedReport()
            .then((response: any) => {
                this.setState({
                    data: response.result
                })
            }).catch((error) => {
            this.setState({
                data: []
            })
        })
    };

    private imageFormListener = (response: any) => {
        const result: IFileRequest = {
            name: response.name,
            base64: response.base64,
            size: response.file.size,
            type: response.type

        };

        const request = this.state.request;

        this.setState({
            imageRequest: result,
            request
        });
    };

    private formListener = (e: any) => {
        const field = e.target.name;
        const value = e.target.value;

        this.setState(prevState => ({
            request:
                {
                    ...prevState.request,
                    [field]: value
                }
        }));
    };

    private sendReport = (e: any, category: string) => {

        this.setState({
            coreState: StateManager.showLoadingNotification(this.state.coreState)
        });

        const request = this.state.request;
        request.category = category;

        if(this.state.imageRequest !== undefined){
            request.imageFile = this.state.imageRequest;
        }

        this.apiService.create(request)
            .then((data: any) => {

                this.setState({
                    coreState: StateManager.hideLoadingNotification(this.state.coreState)
                });

                window.location.href = '/aspirasi-pengaduan/success';

            }).catch((error: any) => {
                console.log(error);
            this.setState({
                coreState: StateManager.showErrorNotification(this.state.coreState, error.errorMessage)
            });

        });

        e.preventDefault();
    };

}


// WEBPACK FOOTER //
// ./src/screen/society-report/SocietyReport.tsx